export default __webpack_public_path__ + "static/media/todolist.079db484.jpg";